import type { EntityReference } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

function getCompetitionsRefData(): Promise<EntityReference[]> {
  return requestApiJsonOrThrow<EntityReference[]>('admin/reference-data/competitions')
}

export const competitionsRefDataQuery = {
  queryKey: ['competitions-ref-data'],
  queryFn: () => getCompetitionsRefData(),
}
